(function () {
    'use strict';

    angular
        .module('app')
        .controller('FollowersController', FollowersController);

        FollowersController.$inject = ['$rootScope', '$stateParams', '$http', '$state'];

    function FollowersController($rootScope, $stateParams, $http, $state) {
        var vm = this;
        vm.$onInit = init;
        $rootScope.header_inverted = false;
        $rootScope.on_dashboard = false;
        $rootScope.separate_page = false;
        $rootScope.dark_text_header = true;
        vm.showUserProfile = [];


        function init() {
            vm.profile_type = $stateParams.profile_type;
            vm.profile_slug = $stateParams.profile_slug;
            checkProfileOwner();
            if($stateParams.followers){
                vm.followers = $stateParams.followers;
            } else {
                getFollowers();
            }
            getProfile();
        }

        function getFollowers(){
            if(vm.profile_type == 'band'){
                $http.get('api/followers/artist/' + vm.profile_slug)
                    .then(function (response) {
                        vm.followers = response.data
                    });
            }
            if(vm.profile_type == 'space'){
                $http.get('api/followers/host/' + vm.profile_slug)
                    .then(function (response) {
                        vm.followers = response.data
                    });
            }
        }

        function getProfile(){
            if(vm.profile_type == 'space'){
                return $http.get('api/spaces/'+vm.profile_slug+'/')
                .then(function (response) {
                    vm.profile_name = response.data.space_name;
                    vm.profile = response.data;
                });
            }
            if(vm.profile_type == 'band'){
                return $http.get('api/bands/'+vm.profile_slug+'/')
                .then(function (response) {
                    vm.profile_name = response.data.band_name;
                    vm.profile = response.data;
                });
            }
        }

        function checkProfileOwner(){
            if(vm.profile_type == 'band'){
                $http.get('api/users/check_profile_owner/' + 'band' + '/' + vm.profile_slug)
                .then(function (response) {
                    if(response.data.user_owns_profile == false){
                        $state.go('frontpage');
                    };
                });
            }
            if(vm.profile_type == 'space'){
                $http.get('api/users/check_profile_owner/' + 'space' + '/' + vm.profile_slug)
                .then(function (response) {
                    if(response.data.user_owns_profile == false){
                        $state.go('frontpage');
                    };
                });
            }
        }
    }
})();
